<template>
  <!-- 社群关联设置 -->
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            ID：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.chat_id"
              placeholder="请输入群ID"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            群名称：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.chat_name"
              placeholder="请输入群名称"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">
            工号：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.employee_number"
              placeholder="请输入管理员工号"
              class="input-m m-r-6"
              clearable
            />
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </div>
    </div>

    <div class="f-toolbar-block">
      <el-button
        type="primary"
        @click="importVisible = true"
      >
        通过群主导入群
      </el-button>
      <el-button
        type="primary"
        @click="haddleExport"
      >
        批量导出
      </el-button>
    </div>

    <div class="f-table-block">
      <el-table
        v-loading="loading"
        :data="list"
      >
        <el-table-column
          prop="chat_id"
          label="群ID"
          min-width="150"
        />
        <el-table-column
          prop="name"
          label="群名称"
          min-width="150"
        />
        <el-table-column
          label="群管理员"
          min-width="150"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.salesperson">{{ scope.row.salesperson.salesperson_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="群管理员工号"
          min-width="150"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.salesperson">{{ scope.row.salesperson.employee_number }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="群状态"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">
              <el-tag
                type="success"
                effect="dark"
                size="mini"
              > 正常 </el-tag>
            </span>
            <span v-if="scope.row.status === 2">已解散</span>
            <span v-if="scope.row.status === 3">变更群主</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          width="200"
        />
      </el-table>

      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 批量导入 -->
    <SpBulkImport
      v-model="importVisible"
      file-type="group_customer_base"
      title="批量导入客户群"
      @saveImportAction="saveImportAction"
    >
      <div>
        批量导入说明： <br>
        1、下载客户群模版文件<br>
        2、根据填写要求填写客户群，上传并导入文件，文件格式必须为xlsx<br>
        3、单次上传xlsx最大条目数（行数）为5000，超出请按文件分批上传<br>
        4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传
      </div>
    </SpBulkImport>

    <!-- 批量导出 -->
    <el-dialog
      title="批量导出群"
      :visible.sync="codeVisible"
      width="1025px"
    >
      <div>
        <div class="dialog-tips">
          批量导出说明： <br>
          1、请选择数据序号导出群，为避免消耗服务器性能，一次最高导出1000条群数据<br>
          2、导出的数据按照搜索条件查询后的结果，进行导出。若查询条件为空，则默认展示有群数据条数
        </div>
        <div class="export-content">
          <el-button
            v-for="(item, index) in section"
            :key="index"
            type="primary"
            @click="downLoadSection(item)"
          >
            确定导出({{ item.text }})
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberShipList, getExportList, exportList } from '@/api/membership/membershipList'

export default {
  data () {
    return {
      params: {
        chat_id: '',
        chat_name: '',
        employee_number: '',
        page: 1,
        page_size: 20
      },
      list: [],
      total_count: 0,
      loading: false,

      // 批量导入
      importVisible: false,

      // 批量导出
      codeVisible: false,
      section: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      this.loading = true
      const data = await getMemberShipList(this.params).catch(() => {
        this.loading = false
      })
      if (data) {
        this.list = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },
    // 列表点击切换tab
    handleClick () {
      this.params.page = 1
      this.searchList()
    },

    // 查询列表数据
    searchList () {
      this.params.page = 1
      this.getList()
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 确定导入
    saveImportAction () {
      this.params.page = 1
      this.getList()
    },

    // 获取批量导出列表
    async getExportList () {
      const { chat_id, chat_name, employee_number } = this.params
      let params = { chat_id, chat_name, employee_number }
      const data = await getExportList(params)
      if (data) {
        data.map((v) => {
          v.text = v.head + '~' + v.tail
        })
        this.section = data
      }
    },
    //批量导出
    haddleExport () {
      this.codeVisible = true
      this.getExportList()
    },
    // 确定批量导出
    async downLoadSection (item) {
      this.downLoadZip(item)
    },

    // 批量导出
    async downLoadZip (item) {
      const { chat_id, chat_name, employee_number } = this.params
      let params = {
        chat_id,
        chat_name,
        employee_number,
        head: item.head,
        tail: item.tail
      }
      const data = await exportList(params)
      if (data) {
        const a = document.createElement('a')
        a.href = data.url
        a.download = data.file_name
        a.click()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.dialog-tips {
  color: #999999;
  font-size: 12px;
  line-height: 24px;
}
.import-body {
  margin-top: -20px;
  .import-content {
    height: auto;
    margin-bottom: 25px;
  }
  .importBtns {
    height: auto;
    position: relative;
  }
  .button-right {
    display: flex;
    align-items: center;
    position: absolute;
    left: 84px;
    top: 0;
    margin: auto;
  }
}
.export-content {
  margin-top: 20px;
}
</style>
